import React from 'react';
import { useSelector } from 'react-redux';

const QueueModal = ({ patientInfo, onInputChange, onSubmit, onClose }) => {

  const theme = useSelector((state) => state.theme.theme) || "light";
  return (
    <div className="modal-overlay-citas">
      <div className="modal-container-citas card_background">
        <div className="modal-header-citas">
          <h3 style={{ fontSize:"1.25rem" }}>Ingresar a cola de espera</h3>
          <button className="close-btn" onClick={onClose}>
            ×
          </button>
        </div>

        <p className="modal-description-citas">
          Te agregaremos a nuestra lista de espera y te contactaremos si hay una
          cancelación.
        </p>

        <form onSubmit={onSubmit}>
          <div className="form-group">
            <label style={{ color: theme === "dark" && "#c3cbe4" }}>
              Nombre completo <span className="required">*</span>
            </label>
            <input
              type="text"
              name="name"
              value={patientInfo.name}
              onChange={onInputChange}
              required
              className="input_background"
            />
          </div>

          <div className="form-group">
            <label style={{ color: theme === "dark" && "#c3cbe4" }}>
              Teléfono <span className="required">*</span>
            </label>
            <input
              type="tel"
              name="phone"
              value={patientInfo.phone}
              onChange={onInputChange}
              required
              className="input_background"
            />
          </div>

          <div className="form-group">
            <label style={{ color: theme === "dark" && "#c3cbe4" }}>
              Motivo de la consulta
            </label>
            <textarea
              name="reason"
              value={patientInfo.reason}
              onChange={onInputChange}
              rows="3"
              className="input_background"
            />
          </div>

          <div className="form-actions">
            <button type="button" className="cancel-btn" onClick={onClose}>
              Cancelar
            </button>
            <button type="submit" className="confirm-btn">
              Ingresar a cola
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default QueueModal;